import { environment } from '@/environments/environment';

/**
 * Mixpanel api_host. Gateway path is /mp on apiBaseUrl.
 * withCredentials is stripped via mixpanel-xhr-credentials.patch so direct
 * cross-origin calls to api.doktar.cc work without a localhost proxy.
 */
export function getMixpanelApiHost(): string {
  return environment.apiBaseUrl ? `${environment.apiBaseUrl}/mp` : 'https://api.doktar.cc/mp';
}
